import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_49_1W_22',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_49_1w_22_usd',
		},
		primer: 'prd_rOf8QoQqkDsI',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 22,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 49,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('female_yoga.pages.paywall.plans.1_week.into_period_text'), // '7 days'
		explicitTermsIntervalText: $tc('common.week_plural', 4), // '4 weeks',
		billingSubtitlePeriodText: $tc('common.duration.week.first', 1), // 'first week'
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 1), // '1-week'
		footerIntervalText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week',
	}),
}
